<div class="error-page">
  <div class="content-box">
    <h1>{{errorTitle()}}</h1>
    <p class="text">{{errorMessage()}}</p>
  </div>
</div>
